import { status } from "skin/event/status";
import next from "./next";

// Выгрузка json конфигурации в txt файл
const loadJSON = (obj, ms, story, data, d, action) => {
  if (obj.code === "btn") next(obj, ms, story, data, d, action);
  else return status.action;
};
export default loadJSON;
